import {BASE_URL} from "@/utils";
import {AxiosRequestConfig} from "axios";
import getToken from "@/utils/getToken";
import getAxiosObj from "@/utils/request";
import {IBroadcastFeed} from "@/types/IBroadcastFeed";

export const getBroadcastChannelFeedByIdV2 = async (
  channelId: string,
  attr: string = "") => {
  let url;
  if (attr === "") {
    url = `${BASE_URL}/bro/GetBroadcastContentV2?channel_id=${channelId}&limit=20`
  } else {
    url = `${BASE_URL}/bro/GetBroadcastContentV2?channel_id=${channelId}&limit=20&${attr}`
  }
  const config: AxiosRequestConfig = {
    headers: {
      "Authorization": `Bearer ${getToken()}`
    },
    maxBodyLength: Infinity,
    method: "GET",
    url,
  };

  const axiosObj = getAxiosObj();

  const response = await axiosObj<IBroadcastFeed[]>(config);
  return response.data;
}